import { opportunityRoutine, seeMoreRoutine, OPPORTUNITY_CLEANUP, SEE_MORE_CLEANUP } from './routines'
import { logoutRoutine } from '@/store/modules/auth/routines'
import { getOpportunityList } from '@product/api/opportunity'
import requestFlow from '@/utils/requestFlow'
import { state as initialState } from './index'

export default {
  ...requestFlow(opportunityRoutine, getOpportunityList).actions,

  [seeMoreRoutine.TRIGGER](context, payload) {
    context.commit(seeMoreRoutine.SUCCESS, payload)
  },

  [logoutRoutine.SUCCESS](context) {
    context.commit(OPPORTUNITY_CLEANUP, initialState)
    context.commit(SEE_MORE_CLEANUP, initialState)
  }
}
